export enum DocumentDetailsContentType {
    General,
    PipOrPiq,
    FinancialModel,
}

export const DocumentDetailsContentTypeOptions = [
    { id: DocumentDetailsContentType.General, name: 'General' },
    { id: DocumentDetailsContentType.PipOrPiq, name: 'PIP / PIQ' },
    { id: DocumentDetailsContentType.FinancialModel, name: 'Financial Model' },
];
